<template>
  <div class="base-header-notification" @click="handleClick">
    <img
      src="@/assets/images/bell.png"
      class="header-logo-img"
      width="20px"
      height="22px"
      alt="bell"
    />
    <div class="notification-text">お知らせ</div>
    <div class="red-circled-number" v-if="unreadCounts">{{ unreadCounts }}</div>
  </div>
</template>

<script>
export default {
  name: 'BaseHeaderNotification',
  props: {
    unreadCounts: {
      type: [Number, String]
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.base-header-notification {
  margin-top: 16px;
  float: left;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  .header-logo-img {
    float: left;
    width: 20px;
    height: 22px;
  }
  .notification-text {
    float: left;
    margin-left: 10px;
  }
  .red-circled-number {
    float: left;
    margin-left: 15px;
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    color: #{$white};
    font-size: 14px;
    background-color: #{$tomato};
  }
}
@media (max-width: $horizontal-tablet-width) {
  .base-header-notification {
    > .notification-text {
      font-size: 13px;
    }
  }
}
</style>
